/* Nacrelle — fiche produit principale : galerie, zoom, compléments, formule, barre collante, carrousels, pied de page.
   Tous les montants viennent des attributs data-* rendus par Liquid à partir des prix Shopify (centimes). */
(() => {
  const money = (c) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format((Number(c) || 0) / 100).replace(/[\u202F\u2009 ]/g, '\u00A0'); // « 82,99 € » (U+00A0)
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const behavior = reduce ? 'auto' : 'smooth';

  /* ---------- Galerie ---------- */
  document.querySelectorAll('[data-pdp-gallery]').forEach((g) => {
    const track = g.querySelector('[data-track]');
    const slides = [...g.querySelectorAll('.pdp-slide')];
    const thumbs = [...g.querySelectorAll('[data-goto]')];
    const counter = g.querySelector('[data-counter]');
    let index = 0;
    let shown = 0;
    const go = (i) => {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior });
    };
    const setActive = (i) => {
      if (i === shown || i < 0 || i >= slides.length) return; // une seule mise à jour par photo, pas à chaque image du défilement
      shown = i;
      index = i;
      thumbs.forEach((t, k) => { t.classList.toggle('is-active', k === i); t.setAttribute('aria-selected', String(k === i)); });
      if (counter) counter.textContent = String(i + 1);
      const active = thumbs[i];
      if (active) active.parentElement.scrollTo({ left: active.offsetLeft - active.parentElement.offsetLeft - 16, behavior });
    };
    g.querySelectorAll('[data-step]').forEach((b) => b.addEventListener('click', () => go(index + Number(b.dataset.step))));
    thumbs.forEach((t) => t.addEventListener('click', () => go(Number(t.dataset.goto))));
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => setActive(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
    }, { passive: true });
    track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') go(index + 1); if (e.key === 'ArrowLeft') go(index - 1); });

    /* Zoom plein écran */
    const lb = document.querySelector('[data-lightbox]');
    if (lb) {
      const lbTrack = lb.querySelector('[data-lightbox-track]');
      slides.forEach((s) => s.addEventListener('click', () => {
        lb.hidden = false;
        document.documentElement.classList.add('no-scroll');
        const target = lbTrack.children[Number(s.dataset.zoom)];
        requestAnimationFrame(() => lbTrack.scrollTo({ left: target ? target.offsetLeft : 0 }));
        lb.querySelector('[data-lightbox-close]').focus();
      }));
      const close = () => { lb.hidden = true; document.documentElement.classList.remove('no-scroll'); slides[index] && slides[index].focus(); };
      lb.querySelector('[data-lightbox-close]').addEventListener('click', close);
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !lb.hidden) close(); });
    }
  });

  /* ---------- Média animé : image fixe, animation chargée seulement à l'écran (rien au chargement ; jamais en mouvement réduit) ---------- */
  const animated = document.querySelectorAll('img[data-anim-src]');
  if (animated.length && !reduce && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach(({ target: img, isIntersecting }) => {
      img.dataset.poster = img.dataset.poster || img.getAttribute('src');
      img.dataset.wanted = isIntersecting ? '1' : '';
      if (!isIntersecting) { if (img.getAttribute('src') !== img.dataset.poster) img.src = img.dataset.poster; return; }
      const next = new Image();
      next.onload = () => { if (img.dataset.wanted) img.src = img.dataset.animSrc; };
      next.src = img.dataset.animSrc;
    }), { threshold: 0.5 });
    animated.forEach((img) => io.observe(img));
  }

  /* ---------- Photos « La brosse au quotidien » : défilement lent et sans fin (mobile, tablette), balayable au doigt ---------- */
  document.querySelectorAll('.rv-gallery-grid').forEach((row) => {
    if (reduce || !matchMedia('(max-width: 989px)').matches || !('IntersectionObserver' in window)) return;
    const originals = [...row.children];
    if (originals.length < 2) return;
    const setup = () => {
    originals.forEach((li) => {
      const clone = li.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      const btn = clone.querySelector('button');
      btn.removeAttribute('data-rv-photo'); // la visionneuse ne compte que les originaux
      btn.removeAttribute('aria-label');
      btn.tabIndex = -1;
      btn.addEventListener('click', () => li.querySelector('button').click());
      clone.querySelector('img').alt = '';
      row.appendChild(clone);
    });
    row.classList.add('is-looping');
    const SPEED = 24; // px par seconde
    const firstClone = row.children[originals.length];
    const dialog = row.parentElement.querySelector('dialog');
    const span = () => firstClone.offsetLeft - originals[0].offsetLeft;
    let pos = 0; let last = 0; let holdUntil = 0; let visible = false; let raf = 0; let touching = false;
    const tick = (t) => {
      raf = 0;
      if (!visible) return;
      raf = requestAnimationFrame(tick);
      const dt = last ? Math.min(t - last, 100) : 0;
      last = t;
      if (touching || t < holdUntil || (dialog && dialog.open)) return;
      pos += (SPEED * dt) / 1000;
      const w = span();
      if (pos >= w) pos -= w;
      row.scrollLeft = pos;
    };
    new IntersectionObserver(([en]) => {
      visible = en.isIntersecting;
      last = 0;
      if (visible && !raf) raf = requestAnimationFrame(tick);
    }).observe(row);
    const release = () => { touching = false; holdUntil = performance.now() + 1800; };
    row.addEventListener('touchstart', () => { touching = true; }, { passive: true });
    row.addEventListener('touchend', release, { passive: true });
    row.addEventListener('touchcancel', release, { passive: true });
    row.addEventListener('mouseenter', () => { touching = true; });
    row.addEventListener('mouseleave', release);
    row.addEventListener('scroll', () => {
      const now = performance.now();
      if (!touching && now >= holdUntil) return; // défilement automatique
      if (!touching) holdUntil = now + 1200; // élan du doigt encore en cours
      const w = span();
      if (row.scrollLeft >= w) row.scrollLeft -= w;
      else if (row.scrollLeft <= 0) row.scrollLeft += w;
      pos = row.scrollLeft;
    }, { passive: true });
    };
    // Rien à cloner tant que la rangée est loin de l'écran.
    new IntersectionObserver((en, o) => { if (en[0].isIntersecting) { o.disconnect(); setup(); } }, { rootMargin: '500px 0px' }).observe(row);
  });

  /* ---------- Modales (contenu du renouvellement) ---------- */
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-modal-open]');
    if (opener) {
      e.preventDefault();
      const m = document.getElementById(opener.dataset.modalOpen);
      if (m) { m.hidden = false; document.documentElement.classList.add('no-scroll'); m.querySelector('.modal-close').focus(); m._opener = opener; }
      return;
    }
    const closer = e.target.closest('[data-modal-close]');
    if (closer) {
      const m = closer.closest('[data-modal]');
      if (m) { m.hidden = true; document.documentElement.classList.remove('no-scroll'); m._opener && m._opener.focus(); }
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-modal]:not([hidden])').forEach((m) => { m.hidden = true; document.documentElement.classList.remove('no-scroll'); });
  });

  /* ---------- Formule + compléments + bouton ---------- */
  const form = document.querySelector('[data-brush-form]');
  if (form) {
    const err = form.querySelector('[data-form-error]');
    const labels = document.querySelectorAll('[data-atc-label]');
    const priceMain = document.querySelector('[data-price-main]');
    const save = document.querySelector('[data-save]');
    const fieldset = form.querySelector('.pdp-formulas');
    const formula = () => (form.querySelector('input[name="formula"]:checked') || {}).value || '';
    const base = () => (formula() === 'renouvellement' ? Number(form.dataset.subPrice) : Number(form.dataset.brushPrice));
    const total = () => base();

    const refresh = () => {
      const f = formula();
      const text = f ? `Ajouter au panier — ${money(total())}` : 'Choisissez votre formule';
      labels.forEach((l) => {
        if (l.textContent !== text && document.documentElement.classList.contains('m-ready')) { const b = l.closest('.pdp-atc'); b.classList.remove('is-updated'); void b.offsetWidth; b.classList.add('is-updated'); }
        l.textContent = text;
      });
      if (priceMain) priceMain.textContent = money(f === 'renouvellement' ? Number(form.dataset.subPrice) : Number(form.dataset.brushPrice));
      if (save) save.hidden = f !== 'renouvellement';
      document.querySelectorAll('[data-compare]').forEach((el) => { el.hidden = f !== 'renouvellement'; });
      form.classList.toggle('has-formula', Boolean(f));
      fieldset.classList.remove('needs-choice');
    };
    form.addEventListener('change', (e) => {
      if (e.target.name === 'formula') form.querySelectorAll('.formula-tile').forEach((t) => t.classList.toggle('just-picked', t.contains(e.target)));
      refresh();
    });
    refresh();

    const askFormula = () => {
      fieldset.classList.add('needs-choice');
      fieldset.scrollIntoView({ behavior, block: 'center' });
      const first = fieldset.querySelector('input[name="formula"]');
      if (first) first.focus({ preventScroll: true });
    };

    let busy = false;
    const submit = async () => {
      if (busy) return;
      const f = formula();
      if (!f) { askFormula(); return; }
      busy = true;
      const buttons = document.querySelectorAll('[data-add-btn], [data-sticky-buy]');
      buttons.forEach((b) => { b.disabled = true; b.classList.add('is-loading'); });
      err.hidden = true;
      try {
        await window.NacrelleCart.setMain(f, { brush: Number(form.dataset.brushVariant), head: Number(form.dataset.headVariant), plan: Number(form.dataset.sellingPlan), note: `${money(Number(form.dataset.subPrice))} aujourd'hui au lieu de ${money(Number(form.dataset.brushPrice))} en achat unique, soit ${money(Number(form.dataset.brushPrice) - Number(form.dataset.subPrice)).replace(',00', '')} d'économie` });
      } catch (ex) {
        err.textContent = (ex && ex.description) || 'Une erreur est survenue. Merci de réessayer.';
        err.hidden = false;
      }
      buttons.forEach((b) => { b.disabled = false; b.classList.remove('is-loading'); });
      busy = false;
    };
    form.addEventListener('submit', (e) => { e.preventDefault(); submit(); });

    /* Barre collante : visible sur mobile quand le bouton principal est hors écran, masquée au niveau du pied de page. */
    const sticky = document.querySelector('[data-pdp-sticky]');
    const mainBtn = form.querySelector('[data-add-btn]');
    const footer = document.querySelector('[data-footer]');
    if (sticky && mainBtn) {
      sticky.querySelector('[data-sticky-buy]').addEventListener('click', () => submit());
      let btnVisible = true; let footerVisible = false;
      const update = () => { sticky.classList.toggle('is-visible', !btnVisible && !footerVisible); };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([en]) => { btnVisible = en.isIntersecting; update(); }).observe(mainBtn);
        if (footer) new IntersectionObserver(([en]) => { footerVisible = en.isIntersecting; update(); }).observe(footer);
      }
      document.body.classList.add('has-pdp-sticky');
    }
  }

  /* ---------- Carrousels ---------- */
  document.querySelectorAll('.carousel-sec').forEach((sec) => {
    const track = sec.querySelector('[data-carousel]');
    if (!track) return;
    sec.querySelectorAll('[data-carousel-step]').forEach((b) => b.addEventListener('click', () => {
      const card = track.firstElementChild;
      const step = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
      track.scrollBy({ left: step * Number(b.dataset.carouselStep), behavior });
    }));
  });

  /* ---------- Pied de page : groupes ouverts sur desktop ---------- */
  const mq = matchMedia('(min-width: 900px)');
  const syncFooter = () => document.querySelectorAll('[data-footer-group]').forEach((d) => { d.open = mq.matches; });
  syncFooter();
  mq.addEventListener('change', syncFooter);
})();
